"use client";

import { c as _c } from "react/compiler-runtime";
type TextareaFieldProps = {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  height?: string;
};
export default function TextareaField(t0) {
  const $ = _c(10);
  const {
    placeholder,
    value,
    onChange,
    className: t1,
    height
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== onChange) {
    t2 = e => onChange?.(e.target.value);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `w-full px-3 py-3 border border-DCDCDC outline-none bg-FFFFFF resize-none text-14-tamil-300 leading-[1.4] line-clamp-1 text-1B1B1B ${className}`;
  let t4;
  if ($[2] !== height) {
    t4 = {
      height
    };
    $[2] = height;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== placeholder || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== value) {
    t5 = <textarea placeholder={placeholder} value={value} onChange={t2} className={t3} style={t4} />;
    $[4] = placeholder;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}